<template>
    <div class="form-group mb-8">
        <label>{{ __("general.category") }}</label>
        <Treeselect
            v-model="value"
            :placeholder="__('product.product_section.category_placeholder')"
            :options="options"
            :normalizer="normalizer"
            :no-results-text="__('product.product_section.category_no_results')"
            :disable-branch-nodes="true"
            @select="(node) => categorySelected(node)"
            :limit-text="
                (count) =>
                    `${__('product.product_section.category_more', {
                        count: count,
                    })}`
            "
            auto-load-root-options
        />
        <small class="form-text text-muted">
            {{ __("product.product_section.article_category") }}
        </small>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "CategorySelection",
    components: { Treeselect },
    data() {
        return {
            value: null,
            options: [],
            normalizer(node) {
                return {
                    id: node.id,
                    label: node.name,
                    children: node.children,
                };
            },
        };
    },
    props: {
        oldValue: Number,
    },
    methods: {
        categorySelected(node) {
            this.$emit("setCategoryId", node.id);
            this.$emit("setCategory", node);
        },
    },

    async mounted() {
        let { data } = await axios.get(this.$route("category-tree"));
        this.options = data;
        this.value = this.oldValue;
    },
};
</script>
